import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import cookie from "react-cookie";

import Alert from "react-s-alert";

const jwtToken = cookie.load("jwt-token");
const State = Record(
  {
    formLoading: false,
    error: null,
    viewer: null,
    token: jwtToken,
    refreshTokenInterval: null
  },
  "auth"
);

const authReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.SIGN_IN: {
      return state.set("formLoading", true);
    }

    case actions.SIGN_IN_SUCCESS: {
      const { body } = action.payload;
      cookie.save("jwt-token", body, { path: "/" });
      return state.set("token", body).set("formLoading", false);
    }

    case actions.SIGN_IN_ERROR: {
      const { errors, data } = action.payload;
      return state.set("error", errors).set("formLoading", false);
    }

    case actions.SIGN_IN_FINALLY: {
      return state.set("formLoading", false);
    }

    case actions.SIGN_OUT: {
      cookie.remove("jwt-token", { path: "/" });
      return state.set("token", null);
    }

    case actions.REFRESH_TOKEN_SUCCESS: {
      const { body } = action.payload;
      cookie.save("jwt-token", body, { path: "/" });
      return state.set("token", body);
    }

    case actions.REMOVE_TOKEN: {
      cookie.remove("jwt-token", { path: "/" });
      return state.set("token", null);
    }

    case actions.SET_REFRESH_TOKEN_INTERVAL: {
      const { interval } = action.payload;

      return state.set("refreshTokenInterval", interval);
    }

    case actions.GET_CURRENT_ADMIN_SUCCESS: {
      const { body, data } = action.payload;
      return state.set("viewer", body);
    }

    case actions.AUTH_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors = state.error && state.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.set("error", new ValidationError(errors));
    }

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/common/auth/reducer.js